export const globalCss = {
  body: {
    fontFamily: "fonts.body",
  },

  ":focus-visible": {
    outline: "none !important",

    boxShadow: "0 0 0 4px var(--chakra-colors-focus-500)",
  },

  "a:focus, a:focus-visible, button:focus, button:focus-visible, input:focus, input:focus-visible, textarea:focus, textarea:focus-visible, select:focus, select:focus-visible":
    {
      position: "relative",
      zIndex: "30 !important",
    },

  "a:not(.focus-bordered, .focus-none, .focus-keyboard-only):focus, a:not(.focus-bordered, .focus-none, .focus-keyboard-only):focus *":
    {
      color: "white !important",
    },
  "a:not(.focus-bordered, .focus-none, .focus-keyboard-only):focus": {
    backgroundColor: "var(--chakra-colors-focus-500)",
  },
  "a:not(.focus-bordered, .focus-none):focus-visible, a:not(.focus-bordered, .focus-none):focus-visible *":
    {
      color: "white !important",
    },
  "a:not(.focus-bordered, .focus-none):focus-visible": {
    backgroundColor: "var(--chakra-colors-focus-500)",
  },

  ".focus-none:focus, .focus-none:focus-visible": {
    outline: "none !important",
    boxShadow: "none !important",
    animation: "none !important",
  },

  ".focus-keyboard-only:focus:not(:focus-visible)": {
    outline: "none !important",
    boxShadow: "none !important",
    animation: "none !important",
  },

  ".focus-bordered:focus, .focus-bordered:focus-visible": {
    outline: "none !important",
    boxShadow: "0 0 0 2px transparent, 0 0 0 4px var(--chakra-colors-focus-500)",
    animation: "accessibility-bordered-pulse 300ms ease-in-out !important",
  },

  ".dashboard-category-link:focus, .dashboard-category-link:focus-visible": {
    outline: "none !important",
  },

  html: {
    scrollBehavior: "smooth",
  },

  "@keyframes accessibility-outline-pulse": {
    "0%, 100%": { boxShadow: "0 0 0 3px var(--chakra-colors-focus-500)" },
    "50%": { boxShadow: "0 0 0 6px var(--chakra-colors-focus-500)" },
  },

  "@keyframes accessibility-bordered-pulse": {
    "0%, 100%": {
      boxShadow: "0 0 0 2px transparent, 0 0 0 4px var(--chakra-colors-focus-500)",
    },
    "50%": {
      boxShadow: "0 0 0 2px transparent, 0 0 0 6px var(--chakra-colors-focus-500)",
    },
  },

  "@keyframes back-link-focus-pulse": {
    "0%, 100%": {
      boxShadow: "0 -2px 0 0 var(--chakra-colors-focus-500), 0 4px 0 0 #FFFFFF",
    },
    "50%": {
      boxShadow: "0 -4px 0 0 var(--chakra-colors-focus-500), 0 6px 0 0 #FFFFFF",
    },
  },

  "@keyframes see-all-focus-pulse": {
    "0%, 100%": { boxShadow: "0 0 0 0 var(--chakra-colors-focus-500)" },
    "50%": { boxShadow: "0 0 0 3px var(--chakra-colors-focus-500)" },
  },

  "@keyframes menu-item-focus-pulse": {
    "0%, 100%": { boxShadow: "inset 0 0 0 4px var(--chakra-colors-focus-500)" },
    "50%": { boxShadow: "inset 0 0 0 6px var(--chakra-colors-focus-500)" },
  },

  // For table rows where box-shadow can't render (border-collapse) — pulse the
  // outline offset instead, keeping a fixed 4px outline width.
  "@keyframes focus-outline-pulse": {
    "0%, 100%": { outlineOffset: "-4px" },
    "50%": { outlineOffset: "-2px" },
  },

  "a:focus-visible, button:focus-visible, input:focus-visible, textarea:focus-visible, select:focus-visible":
    {
      animation: "accessibility-outline-pulse 300ms ease-in-out !important",
    },

  "@media (prefers-reduced-motion: reduce)": {
    "a:focus-visible, button:focus-visible, input:focus-visible, textarea:focus-visible, select:focus-visible, .focus-bordered:focus-visible":
      {
        animation: "none",
      },
    "button:focus .back-link-content, button:focus-visible .back-link-content, a:focus .see-all-label, a:focus-visible .see-all-label":
      {
        animation: "none",
      },
  },

  ".sr-only": {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    borderWidth: 0,
  },
};
